<template>
  <span class="sort-caret-wrapper" @click="next()">
    <i class="sort-caret asc" :class="{ active: model === 'asc' }" @click.stop="input('asc')" />
    <i class="sort-caret desc" :class="{ active: model === 'desc' }" @click.stop="input('desc')" />
  </span>
</template>

<script setup lang="ts">
import type { VSortCaretOption } from '../types.ts'

const model = defineModel<VSortCaretOption>({ required: true })

function next() {
  if (!model.value) {
    model.value = 'asc'
  } else if (model.value === 'asc') {
    model.value = 'desc'
  } else {
    model.value = ''
  }
}

function input(value: VSortCaretOption) {
  if (value && value === model.value) {
    model.value = ''
  } else {
    model.value = value
  }
}
</script>

<style>
.sort-caret-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  height: 18px;
  width: 18px;
  vertical-align: middle;
  cursor: pointer;
  overflow: initial;
  position: relative;
}

.sort-caret {
  width: 0;
  height: 0;
  border: 4px solid transparent;
  position: absolute;

  &.asc {
    border-bottom-color: var(--color-text-placeholder);
    top: 0px;

    &.active {
      border-bottom-color: var(--color-primary);
    }
  }

  &.desc {
    border-top-color: var(--color-text-placeholder);
    bottom: 0px;

    &.active {
      border-top-color: var(--color-primary);
    }
  }
}
</style>
